<topo-modal [isActive]="isActive" [width]="500">
  <div style="margin: 2rem">
    <div fxLayout="column" fxLayoutAlign="center center">
      <div><topo-logo></topo-logo></div>
      <div>
        <h3>{{ 'APP.NEW-APP-VERSION-AVAILABLE' | translate }}</h3>
      </div>
      <div>
        <h4>{{ 'APP.REFRESH-SECONDS' | translate: { seconds: seconds } }}</h4>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button class="button is-secondary mr-4" (click)="cancelRefresh()">{{ 'APP.CANCEL' | translate }}</button>
        <button class="button is-primary" (click)="reload()">{{ 'APP.REFRESH-NOW' | translate }}</button>
      </div>
    </div>
  </div>
</topo-modal>
